export enum NewContractMethod {
  TOTAL_STAKED = "totalStaked",
  REWARD_RATE = "rewardRate",
}
